import { ICatFilters } from "../state/mcatalogueState";
import * as catalogueAPIUtil from "../../util/mcatalogue/mcatalogueAPIUtil";
import { User } from "../../models/User";
import { ICatalogue } from "../../interfaces/ICatalogue";

import { ICatalogueListResponse } from "../../interfaces/ICatalogueResponse";
import MCatalogueListItem from "../../models/MCatalogueListitem";
import { IArtwork } from "../../interfaces/IArtwork";
import { MArtwork } from "../../models/MArtwork";
export const MRECEIVE_CATALOGUE_LIST = "[Catalogue] MRECEIVE_CATALOGUE_LIST";
export const MRECEIVE_CATALOGUE = "[Catalogues List] MRECEIVE_CATALOGUE";
export const MFETCH_ERROR = "[Catalogues List] MFETCH_ERROR";
export const MIS_LOADING = "[Catalogues List] MIS_LOADING";
export const MCLEAR_FILTERS = "[Catalogue] MCLEAR_FILTERS";
export const MUPDATE_FILTERS = "[Catalogue] MUPDATE_FILTERS";
export const MRECEIVE_CATALOGUE_ITEM = "[Catalogue] MRECEIVE_CATALOGUE_ITEM";
export const MRECEIVE_CREATED_ORDER = "[Order] MRECEIVE_CREATED_ORDER";
export const MRECEIVE_CATALOGUE_CATEGORIES = "[Categories] MRECEIVE_CATALOGUE_CATEGORIES";
export const MSET_URL_CATEGORY = "[Category] MSET_URL_CATEGORY";
export const MRECEIVE_DECORATION_TYPE = "[Types] MRECEIVE_DECORATION_TYPE";
export const MRECEIVE_DECORATION_LOCATIONS = "[Locations] MRECEIVE_DECORATION_LOCATIONS";
export const MUPDATE_CURRENT_ORDER = "[Current Order] MUPDATE_CURRENT_ORDER";
export const RECEIVE_MCARTWORK_DETAILS = "[Artwork Details] RECEIVE_MCARTWORK_DETAILS";
export const RECEIVE_MCARTWORKS_LIST = "[Artwork Details] RECEIVE_MCARTWORKS_LIST";
export const RECEIVE_MDECORATORS_VENDORS_LIST = "[decorators vendor list] RECEIVE_MDECORATORS_VENDORS_LIST";
export const RECEIVE_MDECORATORS_TYPE_LIST = "[decorators vendor list] RECEIVE_MDECORATORS_TYPE_LIST";

export const receiveArtworks = (artworks: IArtwork[]) => ({
    type: RECEIVE_MCARTWORKS_LIST,
    payload: artworks,
});
export const receiveArtworkDetails = (artworkDetails: {}) => ({
    type: RECEIVE_MCARTWORK_DETAILS,
    payload: artworkDetails,
});
export const receiveCatalogues = (catalogues: ICatalogue[], count: number,meta) => ({
    type: MRECEIVE_CATALOGUE,
    payload: catalogues,
    count,
    meta
});
export const receiveDecorationLocations = (types: []) => ({
    type: MRECEIVE_DECORATION_LOCATIONS,
    payload: types,
});
export const receiveDecorationType = (types: []) => ({
    type: MRECEIVE_DECORATION_TYPE,
    payload: types,
});
export const receiveCatalogueCustomRows = (order) => ({
    type: MRECEIVE_CREATED_ORDER,
    payload: order,   
});
export const receiveCatalogue = (catalogue: ICatalogue) => ({
    type: MRECEIVE_CATALOGUE_ITEM,
    payload: catalogue
});
export const receiveCatalogueCategories = (categories) => ({
    type: MRECEIVE_CATALOGUE_CATEGORIES,
    payload: categories
});
export const fetchCatalogues = (limit: number = 50, offset: number = 0,order:string="productName", orient: string = "asc", filters: ICatFilters) => dispatch => catalogueAPIUtil.fetchCatalogues(limit, offset, order, orient, filters)
.then(res => {
     console.log(res)
     const catalogueResponse: ICatalogueListResponse = res.data;
     const catalogueList: ICatalogue[] = catalogueResponse.data.map(individualCatalogue => {
         return new MCatalogueListItem(individualCatalogue);
     });
     dispatch(receiveCatalogues(catalogueList, catalogueResponse.meta.page_count,catalogueResponse.meta))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const fetchCatalogue = (id,account_id) => dispatch => catalogueAPIUtil.fetchCatalogue(id,account_id)
.then(res => {
     console.log(res)
     const catalogueres=res.data.data;    
     dispatch(receiveCatalogue(catalogueres))    
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const fetchCatalogueCategories = () => dispatch => catalogueAPIUtil.fetchCatalogueCategories()
.then(res => {      
     const cate=res.data.data;    
     const categories=[];
     if(cate.length >0){
        cate.map(c=>{
            categories.push(c.category);
        })
     }
     dispatch(receiveCatalogueCategories(categories))    
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const createOrder = (data,ses) => dispatch => catalogueAPIUtil.createOrder(data)
.then(res => {
     const Orderreceived=res.data.data;      
}).catch(error => {
    console.log("products list error", error);
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const fetchDecorationTypes = () => dispatch => catalogueAPIUtil.fetchDecorationTypes()
.then(res => {
     dispatch(receiveDecorationType(res.data))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const fetchDecorationLocations = () => dispatch => catalogueAPIUtil.fetchDecorationLocations()
.then(res => {
     dispatch(receiveDecorationLocations(res.data))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const isLoading = (loading: boolean) => ({
    type: MIS_LOADING,
    loading
});

export const sendFetchError = () => ({
    type: MFETCH_ERROR
});
export const setCategory = (cat) => ({
    type: MSET_URL_CATEGORY,
    payload:cat
});

export const clearFilters = (currentUser: User) => ({
    type: MCLEAR_FILTERS,
    currentUser
});

export const receiveFilterUpdate = (filter: { [key: string]: any }) => ({
    type: MUPDATE_FILTERS,
    payload: filter,
});
export const updateCurrentOrder = (order) => ({
    type: MUPDATE_CURRENT_ORDER,
    payload:order
});
export const setisLoading = (loading: boolean) =>dispatch=> {
    dispatch(isLoading(loading));
};
export const fetchArtworks = (filterData) => dispatch => catalogueAPIUtil.fetchArtworks(filterData)
  .then(res => {
    const artworks: MArtwork[] = res.data.data.map(individualOrder => {
      return new MArtwork(individualOrder)
    })
    const pendingArtworkData = JSON.parse(localStorage.getItem('cpPendingArtwork') || '[]')
    artworks.unshift(...pendingArtworkData)
    dispatch(isLoading(false))
    dispatch(receiveArtworks(artworks))
  }).catch(error => {
    dispatch(isLoading(false))
    dispatch(sendFetchError())
  })
export const fetchArtworkdetail = (id) => dispatch => catalogueAPIUtil.fetchArtworkdetail(id)
.then(res => {
     dispatch(receiveArtworkDetails(res.data))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const receiveDecoratorVendors = (types) => ({
    type: RECEIVE_MDECORATORS_VENDORS_LIST,
    payload: types,
});
export const getDecoratorVendors = () => dispatch => catalogueAPIUtil.getDecoratorVendors()
.then(res => {
     dispatch(isLoading(false));
     dispatch(receiveDecoratorVendors(res.data))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
export const receiveDecoratorTypes = (types) => ({
    type: RECEIVE_MDECORATORS_TYPE_LIST,
    payload: types,
});
export const getDecoratorTypes = () => dispatch => catalogueAPIUtil.getDecoratorTypes()
.then(res => {
     dispatch(isLoading(false));
     dispatch(receiveDecoratorTypes(res.data))
}).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
});
